module.exports = __webpack_public_path__ + "media/application/images/svgs/social_linkedin-b4df3817103cb8c42a795ab258aa5270.svg";